import {
    Subject
} from 'one-state-subject/src/Subject';
import { diff, format } from 'one-util-date';
import {
    EmergencyDetails
} from 'one-state-subject';
import {
    EmployerDetails
} from 'one-state-subject';

// ADPAC-316
function sortFunction(a: Subject, b: Subject) {
    console.log(a,b,"nexxttgen")
    const nameA = a.lastname.toLowerCase();
    const nameB = b.lastname.toLowerCase();
    return (nameA > nameB) ? 1 : -1;

}
const checkAge = (dob: any) => {
    let age = "";
    if (dob !== undefined && dob !== null && dob !== "") {
        age = diff(dob).toString();
    }
    return age;
}

export const formatPhoneNumber = (phoneNumberString: any) => {
    let cleaned = ('' + phoneNumberString).replace(/\D/g, '');
    if (cleaned.length == 10) {
        return '(' + cleaned.substring(0, 3) + ') ' + cleaned.substring(3, 6) + '-' + cleaned.substring(6, 10);
    }
    return "";
}
/**
 * This Function transforms the backend response
 * in the Data Model that supports the
 * upcoming Appointments Component
 * @param response has the backend upcoming
 * appointment response
 * @param context has settings etc..
 */
export const TransformResponse = (response: any, context: any) => {
    /**
     * @param result contains the transformed response
     */
    const result: Subject[] = [];

    let subjectresult: any = {
        subjectdata: result,
        error: undefined

    }
    const { log, settings: { epicendpoints, uisettings: { dateformat, prescription_mrn: { mrn_value }, display_patientid } } } = context;
    log.debug("one-epic", "transformation entered", response);

    if (response && (response.status >= 400 || response.type == "error")) {
        subjectresult.error = response;
    }
    //ADPAC-348
    else if (response && response.length > 0) {
        const rs = response;
        rs.map((ele: any) => {
            let source: Subject = {
                initials: "",
                id: "",
                middlename: "",
                mrn: "",
                dob: "",
                gender: "",
                age: "",
                contact: "",
                contact_formatted: "",
                address: "",
                lastname: "",
                firstname: "",
                name: "",
                preferredName: [],
                race: "",
                email: "",
                ssn: "",
                zipcode: "",
                displayid: "",
                displayidtype: "",
                prescriptionMRNData: "",
                emergencycontact: [],
                employmentinfo: [],
                practiceName:"",
                practiceId:""
            }
            function maskNumber(num) {
                let last4 = num.slice(-4);                     // last 4 digits
                let remaining = num.slice(0, -4).length;       // total digits before last 4

                // Split remaining digits into two parts (like xxx-xx-)
                let firstPart = Math.max(remaining - 2, 0);    // first block length
                let secondPart = remaining - firstPart;        // second block length

                let masked = "x".repeat(firstPart) + "-" + "x".repeat(secondPart) + "-" + last4;
                return masked;
            }
            // const displaydata = ele.ID.filter((object: any) => object.Type === display_patientid)
            // const prescription_MRNValue = ele.ID.filter((mrninfo: any) => mrninfo.Type === mrn_value)
            // source.id = id[0].ID;
            // source.mrn = id[0].ID;
            // source.displayid = displaydata[0].ID;
            // source.displayidtype = displaydata[0].Type;
            // source.prescriptionMRNData = prescription_MRNValue.length ? prescription_MRNValue[0].ID : "";
            // source.preferredName = ele.PreferredName;
            source.dob = ele.dateOfBirth ? format(ele.dateOfBirth, dateformat) : "";
            const age = checkAge(ele.dateOfBirth);
            source.age = age ? age : "";
            //source.age = age ? age + " year old " + ele?.Sex : "";
            source.gender = ele?.sex === "M" ? "Male" : ele?.sex === "F" && "Female";
            source.ssn = ele.socialSecurityNumber?maskNumber(ele?.socialSecurityNumber):"";
            let addrstr = "";
            let phone = "";
            let phoneNumbers: any = []
            let email = "";
            let emergencydata: EmergencyDetails[] = [];
            let employerinfo: EmployerDetails[] = [];
            source.mrn = ele.medicalRecordNumber
            source.id = ele.medicalRecordNumber;
             source.PatientID=ele.id
             source.name = ele.lastName+","+ele.firstName
             source.firstname = ele.firstName;
            source.lastname = ele.lastName;
            source.middlename = ele.middleName;
            source.initials = ele.firstName?.charAt(0) + ele.middleName?.charAt(0)
            addrstr = addrstr.concat(ele.street ? ele.street + "," : "");
            addrstr = addrstr.concat(ele.city ? ele.city + "," : "");
            addrstr = addrstr.concat(ele.state ? ele.state + "," : "");
            addrstr = addrstr.concat(ele?.country ? ele?.country + "," : "");
            addrstr = addrstr.concat(ele.zip ? ele.zip : "");
            if(ele.cellPhone !==null){
                phone= ele.cellPhone
                phoneNumbers.push({Type:"Mobile",Number:ele.cellPhone})
            }
            else if(ele.homePhone !==null){
                phone= ele.homePhone
                phoneNumbers.push({Type:"Home",Number:ele.homePhone})

            }
            else if(ele.dayPhone !==null){
                phone= ele.dayPhone
                phoneNumbers.push({Type:"Day Phone",Number:ele.dayPhone})

            }
            email=ele.emailAddress
            source.zipcode = ele.zip;
            source.preferredName = ele.nickname;
            source.address = addrstr;
            source.contact = ele.cellPhone;
            const formatednumber = formatPhoneNumber(phone);
            source.phoneNumbers = phoneNumbers;
            source.contact_formatted = formatednumber === "" ? phone : formatednumber;
            source.email = email;
            source.emergencycontact = emergencydata;
            source.employmentinfo = employerinfo;
            source.displayidtype="MRN";
            source.displayid=ele.medicalRecordNumber
            source.practiceId = ele.practiceid;
            source.practiceName = ele.practicename; 
            result.push(source);
        })
    }
    // ADPAC-316
    result.sort(sortFunction);
    subjectresult.subjectdata = result;
    return subjectresult;
}



